<script>
    import pages from '../pages';
    export let current;
    let mobileMenu = false;
    function mobileOpenMenu() {
        mobileMenu = !mobileMenu;
    }

    function closeMenu() {
        mobileMenu = false;
    }
</script>

<nav class="navbar" aria-label="main navigation">
    <div class="navbar-brand">
        <a class="navbar-item" href="/">
            <img src="/images/logo_no_text.png" alt="The Skill Tree Company Logo">
        </a>
        <span role="button" class="navbar-burger {mobileMenu ? 'is-active' : ''}" aria-label="menu" aria-expanded="false" on:click={mobileOpenMenu}>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
        </span>
    </div>
    <div class="navbar-menu  {mobileMenu ? 'is-active' : ''}">
        <div class="navbar-end">
            {#each pages as page}
                {#if !page.hide_in_navbar}
                    <a class="navbar-item is-tab {current === page.url ? 'is-active' : ''}" href="{page.url}" on:click={closeMenu}>
                        {page.navbar_label || page.title}
                    </a>
                {/if}
            {/each}
        </div>
    </div>
</nav>